export enum ReviewState {
  Initial,
  ReadOnly,
  Edit
}
